export default __webpack_public_path__ + "img/tab1s-0e275732.png";